var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSplit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.98081 14.625C3.60194 14.625 3.28125 14.4938 3.01875 14.2313C2.75625 13.9688 2.625 13.6481 2.625 13.2692V4.73081C2.625 4.35194 2.75625 4.03125 3.01875 3.76875C3.28125 3.50625 3.60194 3.375 3.98081 3.375H6.79331V4.5H3.98081C3.92306 4.5 3.87019 4.52406 3.82219 4.57219C3.77406 4.62019 3.75 4.67306 3.75 4.73081V13.2692C3.75 13.3269 3.77406 13.3798 3.82219 13.4278C3.87019 13.4759 3.92306 13.5 3.98081 13.5H6.79331V14.625H3.98081ZM8.4375 16.125V1.875H9.5625V3.375H14.0192C14.3981 3.375 14.7188 3.50625 14.9813 3.76875C15.2438 4.03125 15.375 4.35194 15.375 4.73081V13.2692C15.375 13.6481 15.2438 13.9688 14.9813 14.2313C14.7188 14.4938 14.3981 14.625 14.0192 14.625H9.5625V16.125H8.4375ZM9.5625 13.5H14.0192C14.0769 13.5 14.1298 13.4759 14.1778 13.4278C14.2259 13.3798 14.25 13.3269 14.25 13.2692V4.73081C14.25 4.67306 14.2259 4.62019 14.1778 4.57219C14.1298 4.52406 14.0769 4.5 14.0192 4.5H9.5625V13.5Z",
    fill: "#212129"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSplit);
export default __webpack_public_path__ + "static/media/split.aedb9a9db54f4566fe2bcd4ffb07775b.svg";
export { ForwardRef as ReactComponent };